/* ===== HERO SLIDER ===== */
(function() {
  var slider = document.querySelector('[data-hero-slider]');
  if (!slider) return;

  var slides = slider.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.hero-dots .dot');
  if (slides.length < 2) return;

  var current = 0;
  var autoSlide;

  function goToSlide(index) {
    slides[current].classList.remove('active');
    if (dots[current]) dots[current].classList.remove('active');
    current = index;
    slides[current].classList.add('active');
    if (dots[current]) dots[current].classList.add('active');
  }

  function nextSlide() {
    goToSlide((current + 1) % slides.length);
  }

  function startAuto() {
    autoSlide = setInterval(nextSlide, 5000);
  }

  function resetAuto() {
    clearInterval(autoSlide);
    startAuto();
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      goToSlide(parseInt(dot.dataset.slide));
      resetAuto();
    });
  });

  startAuto();
})();

/* ===== CAROUSEL SCROLL ===== */
document.querySelectorAll('[data-carousel]').forEach(function(carousel) {
  var track = carousel.querySelector('.carousel-track');
  var prevBtn = carousel.querySelector('.carousel-btn.prev');
  var nextBtn = carousel.querySelector('.carousel-btn.next');
  var scrollAmount = 240;

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }
});

/* ===== PRODUCT TABS ===== */
(function() {
  var tabContainer = document.querySelector('[data-product-tabs]');
  if (!tabContainer) return;

  var tabBtns = tabContainer.querySelectorAll('.tab-btn');
  var grid = document.querySelector('[data-product-grid]');
  if (!grid) return;

  var cards = grid.querySelectorAll('.product-card-wrapper');

  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      tabBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var tab = btn.dataset.tab;

      cards.forEach(function(card) {
        var tabs = card.dataset.tabContent || '';
        if (tab === 'all' || tabs.indexOf(tab) !== -1) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
})();

/* ===== STICKY HEADER SHADOW ===== */
(function() {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (window.scrollY > 10) {
      header.style.boxShadow = '0 4px 14px rgba(0,0,0,0.08)';
    } else {
      header.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';
    }
  });
})();

/* ===== QUANTITY BUTTONS ===== */
document.querySelectorAll('.qty-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var input = btn.parentElement.querySelector('.qty-input');
    var val = parseInt(input.value) || 1;

    if (btn.dataset.action === 'plus') {
      input.value = val + 1;
    } else if (btn.dataset.action === 'minus' && val > 1) {
      input.value = val - 1;
    }

    input.dispatchEvent(new Event('change'));
  });
});

/* ===== PRODUCT PAGE – THUMBNAIL SWITCH ===== */
document.querySelectorAll('.thumbnail').forEach(function(thumb) {
  thumb.addEventListener('click', function() {
    var mainImg = document.getElementById('product-main-img');
    if (!mainImg) return;

    document.querySelectorAll('.thumbnail').forEach(function(t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
    mainImg.src = thumb.dataset.img;
  });
});

/* ===== COLLECTION SORT ===== */
(function() {
  var sortSelect = document.querySelector('[data-sort-select]');
  if (!sortSelect) return;

  sortSelect.addEventListener('change', function() {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });
})();
